/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from "zod/v4";

export const assumptionEntryDtoSchema = z.object({
  key: z.optional(z.string()),
  value: z.optional(z.string()),
});
